import React from 'react'
import styled from 'styled-components'
import GridArea from 'templates/Layout/GridArea'

const StyledComponent = styled(
  ({...rest}) => <GridArea name={'logo'} {...rest} />
)`
  align-self: center;
  position: relative;
  display: inline-flex;
  gap: 6px;

  @media (min-width: ${p => p.theme.mobileSize}) {
    gap: 0;
  }
`

const _PageHeader_Logo_Wrapper = (props) => <StyledComponent {...props} />
_PageHeader_Logo_Wrapper.propTypes = {}
export default _PageHeader_Logo_Wrapper
